import { useDispatch } from "react-redux";
import DepartmentMain from "../../../features/masters/department/components/department-main";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import { useEffect } from "react";

const title = "Master Department";

const DepartmentMasterPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <DepartmentMain />;
};

export default DepartmentMasterPage;
